import styled, { css } from 'styled-components';
import { Headline5, Body4, Body5 } from './../../app/common/typography';

export const AssessmentContainer = styled.div(
  ({ isViewer, isSelf }) => css`
    margin-top: ${isSelf ? '88px' : isViewer ? '185px' : '320px'};
    margin-right: ${({ theme }) => theme.spacing.m};
    margin-left: ${({ theme }) => theme.spacing.m};
    margin-bottom: 90px;
    position: relative;
    display: flex;
    flex-direction: column;
  `
);

export const StarEmployeesContainer = styled.div(
  ({ theme, isSelf, isViewer }) => css`
    background: ${isSelf ? 'unset' : theme.colors.darkBlue};
    padding: ${theme.spacing.none} ${theme.spacing.m};
    display: ${isViewer ? 'none' : 'block'};
  `
);

export const StarEmployeesContent = styled.div`
  padding: ${({ theme }) => theme.spacing.md}
    ${({ theme }) => theme.spacing.none};
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
`;

export const AvatarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const AvatarContent = styled.div`
  position: relative;
  margin-bottom: 6px;
`;

export const StarIconContainer = styled.div`
  right: ${({ theme }) => theme.spacing.none};
  top: -3px;
  position: absolute;
`;

export const TitleOverall = styled.div`
  margin-top: ${({ theme }) => theme.spacing.s};
  display: flex;
  justify-content: space-between;
`;

export const OverallScore = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.xs};
`;

export const BencharmkOverallListItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow:
    0px 0.3px 0.9px rgba(0, 0, 0, 0.1),
    0px 1.6px 3.6px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
  height: ${({ isOpened }) => (isOpened ? '80px' : '50px')};
  padding: 0 ${({ theme }) => theme.spacing.m} 0 20px;
`;

export const BencharmkOverallListItemContent = styled.div`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  .bol-content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .bol-left {
    }
    .bol-right {
      .bol-score-li {
        min-width: 87px;
      }
      .bol-overal-eq {
        min-width: 30px;
      }
      .bol-overal-eq-section {
        min-width: 46px;
        float: left;
      }
    }
  }
`;

export const BenchmarkOverallCollapseContent = styled.div`
  .theme-light {
    background: ${({ theme }) => theme.colors.seasalt} !important;
  }
  .theme-lightest {
    background: ${({ theme }) => theme.colors.white} !important;
  }
  .block-limiter {
    padding-bottom: ${({ theme }) => theme.spacing.m};
    padding-right: 0;
  }
`;

export const HoteLScoreContainer = styled.div(
  ({ theme, isOpened }) => css`
    display: ${isOpened ? 'block' : 'none'};
    .hotel-score-label {
      margin-top: ${theme.spacing.sm};
    }
  `
);

export const DepartamentLabelContainer = styled.div`
  width: ${({ theme }) => theme.width.half};
  height: 21px;
  span {
    width: 130px;
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    font-size: ${({ theme }) => theme.fontSize.xs};
    line-height: ${({ theme }) => theme.spacing.m};
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const DropdownArrowContainer = styled.div<{ expanded: boolean }>`
  transform: ${({ expanded }) => (expanded ? 'rotate(180deg)' : '0')};
  transition: all 0.2s;
  margin-left: 10px;
  float: right;
`;

export const LockInconContainer = styled.div`
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 44%;
  right: 50%;
  bottom: 50%;
`;

export const CardContainer = styled.div`
  padding-top: ${({ theme }) => theme.spacing.m};
  margin-bottom: ${({ theme }) => theme.spacing.xxs};
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled.div``;

export const CardOverall = styled.div`
  display: flex;
`;

export const CardScore = styled(Headline5)`
  margin-right: ${({ theme }) => theme.spacing.xs};
  color: ${({ theme }) => theme.colors.eerieBlack};
`;

export const HotelScoreTitle = styled.div(
  ({ theme, isToggle }) => css`
    display: ${isToggle ? 'block' : 'none'};
    text-align: right;
    margin-top: ${theme.spacing.sm};
    margin-right: ${theme.spacing.l};
  `
);

export const DepartamentCard = styled.div(
  ({ theme, isTheme }) => css`
    background-color: ${isTheme ? theme.colors.seasalt : theme.colors.whit};
    display: flex;
    flex-direction: column;
    padding: ${theme.spacing.m};
    box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
    border-radius: ${theme.radius.xs};
    gap: ${theme.spacing.sm};
  `
);

export const DepartamentText = styled.div`
  width: ${({ theme }) => theme.width.half};
`;

export const DepartamentTitle = styled.div`
  display: flex;
`;

export const DepartamentOverall = styled.div`
  width: ${({ theme }) => theme.width.half};
  display: flex;
  justify-content: center;
`;

export const DepartamentDescription = styled.div`
  display: flex;
`;

export const DepartamentIconsContianer = styled.div`
  width: ${({ theme }) => theme.width.half};
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  align-items: center;
  justify-content: center;
`;

export const ModalContainer = styled.div<{ showEq: boolean }>`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.md} 0;
  padding-top: ${({ theme }) => theme.spacing.none};
  max-height: ${({ showEq }) => (showEq ? '80vh' : 'auto')};
  overflow-y: ${({ showEq }) => (showEq ? 'auto' : 'hidden')};
`;

export const BorderLine = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.platinum};
`;

export const PrimaryEmotionContainer = styled(Body4)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  margin-top: ${({ theme }) => theme.spacing.md};
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const NarrativeTitle = styled(Headline5)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  text-align: left;
`;

export const NarrativeDescription = styled(Body5)`
  color: ${({ theme }) => theme.colors.eerieBlack};
  text-align: left;
`;

export const CompliancySummaryContainer = styled.div`
  color: ${({ theme }) => theme.colors.eerieBlack};
  font-size: ${({ theme }) => theme.fontSize.s};
  text-align: left;

  p {
    margin-bottom: ${({ theme }) => theme.spacing.m};
  }
`;

export const ButtonWrapper = styled.div`
  margin: ${({ theme }) => theme.spacing.m};
`;
